module.exports = __webpack_public_path__ + "img/ico_netflix.b1267d36.png";